import { render, staticRenderFns } from "./UpdateMainboardCarPark.vue?vue&type=template&id=71cb8edc&"
import script from "./UpdateMainboardCarPark.vue?vue&type=script&lang=js&"
export * from "./UpdateMainboardCarPark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports